import { call } from 'redux-saga/effects';
import queryString from 'query-string';
import { API } from '../../api';

export function* getBbox({ serverConfig, filterString }) {
  try {
    const bboxPath = `/bbox/${serverConfig.namespace}?${queryString.stringify({
      props: 'parcel_id',
    })}&${filterString}`;
    const bboxResult = yield call(API, 'get', 'api', bboxPath);
    return bboxResult;
  } catch (e) {
    console.error('Error fetching bbox for multiparcel report', e);
    return;
  }
}
